import router from './router'
import financialClaimMessages from './localization'

export default {
  router,
  localization: financialClaimMessages,
}
